import isUsingArtemisStyles from '../../selectors/isUsingArtemisStyles';

const progressBarMapStateToProps = (state, ownProps) => {
  const pageStep = ownProps.number;
  
  return ({
    active: state.ui.checkoutProgressStep === pageStep,
    complete: state.ui.checkoutProgressStep > pageStep,
    isUsingArtemisStyles: isUsingArtemisStyles(state),
  });
};

export default progressBarMapStateToProps;
